module.exports = __webpack_public_path__ + "static/media/YM06_2.4999b79c.jpg";